(function () {
  'use strict';

  var KLOR_MAX_WAIT = 1500;   // no máximo 1,5s esperando o Klor antes de iniciar
  var STALL_TIMEOUT = 12000;  // sem 1º frame nesse tempo → recomeça o download

  // Só começa depois que a página terminou de carregar (não disputa banda com o site)
  function afterPageLoad(cb) {
    var run = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(cb, { timeout: 2000 });
      else setTimeout(cb, 200);
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  afterPageLoad(function () {
    try { init(); } catch (err) { console.error('InspireWeb Video Script Error:', err); }
  });

  function init() {
    var data = window.inspirewebData || {};
    var currentProduct = data.currentProductHandle || '';
    var currentCollection = data.currentCollectionHandle || '';
    var klorReady = window.inspirewebKlorReady || Promise.resolve();

    var popup = document.getElementById('inspireweb-video-popup');
    var video = document.getElementById('inspireweb-video');
    if (!popup || !video) return;

    var els = {
      mini: popup.querySelector('.inspireweb-video-minimized'),
      expanded: popup.querySelector('.inspireweb-video-expanded'),
      area: popup.querySelector('.inspireweb-video-area'),
      closeExpanded: popup.querySelector('.inspireweb-close-video'),
      closeMini: popup.querySelector('.inspireweb-close-video-min'),
      pagination: popup.querySelector('.inspireweb-pagination'),
      muteBtn: popup.querySelector('.inspireweb-mute-btn'),
      muteBtnMini: popup.querySelector('.inspireweb-mute-btn-popup'),
      titleMini: popup.querySelector('.inspireweb-video-title'),
      titleMax: popup.querySelector('.inspireweb-video-title-max'),
      likeBtn: popup.querySelector('.inspireweb-like-btn'),
      card: document.getElementById('iw-product-card'),
      cardImg: document.getElementById('iw-card-img'),
      cardTitle: document.getElementById('iw-card-title'),
      cardPrice: document.getElementById('iw-card-price'),
      cardBtn: document.getElementById('iw-card-btn')
    };

    var videoList = [];
    var failedUrls = {};
    var bars = [];
    var currentIndex = 0;
    var isMuted = true;
    var expanded = false;
    var started = false;
    var shown = false;
    var closed = false;
    var pauseAllowedUntil = 0;
    var stallTimer = null;
    var preloader = null;

    function filterVideos() {
      var seen = {};
      return ((window.inspirewebData || {}).videos || []).filter(function (v) {
        if (!v || !v.url || seen[v.url] || failedUrls[v.url]) return false;
        seen[v.url] = true;
        if (currentProduct) return !v.product || v.product === currentProduct;
        if (currentCollection) return !v.collection || v.collection === currentCollection;
        return true;
      });
    }

    function allowPause(ms) { pauseAllowedUntil = Date.now() + (ms || 400); }

    function play() {
      if (closed) return;
      var p = video.play();
      if (p && p.catch) p.catch(function (err) {
        if (!err || err.name !== 'NotAllowedError') return;
        if (!video.muted) {
          // Navegador bloqueou som → volta pro mudo e tenta de novo
          isMuted = true;
          video.muted = true;
          updateMuteIcons();
          video.play().catch(function () {});
        } else if (videoList[currentIndex] && videoList[currentIndex].poster) {
          // Autoplay bloqueado (ex.: iPhone em economia de energia) → mostra com a capa
          showPopup();
        }
      });
    }

    function showPopup() {
      if (shown || closed) return;
      shown = true;
      popup.style.display = 'block';
      void popup.offsetWidth; // garante a transição do fade
      popup.classList.add('is-ready');
    }

    function hidePopup() {
      popup.classList.remove('is-ready');
      popup.style.display = 'none';
    }

    // ── Paginação ─────────────────────────────────────────────
    function buildPagination() {
      if (!els.pagination) return;
      var html = '';
      for (var i = 0; i < videoList.length; i++) html += '<div class="bar"><div class="progress"></div></div>';
      els.pagination.innerHTML = html;
      bars = els.pagination.querySelectorAll('.progress');
      syncProgress(video.duration ? (video.currentTime / video.duration) * 100 : 0);
    }

    function syncProgress(pct) {
      for (var i = 0; i < bars.length; i++) {
        bars[i].style.width = i < currentIndex ? '100%' : (i === currentIndex ? pct + '%' : '0%');
      }
    }

    // ── UI ────────────────────────────────────────────────────
    function updateMuteIcons() {
      var icon = isMuted ? '🔇' : '🔊';
      if (els.muteBtn) els.muteBtn.textContent = icon;
      if (els.muteBtnMini) els.muteBtnMini.textContent = icon;
    }

    function updateTexts(v) {
      var title = (v.title || '').toString().trim();
      if (els.titleMini) {
        els.titleMini.textContent = title;
        els.titleMini.style.display = title ? '' : 'none';
      }
      if (els.titleMax) {
        els.titleMax.textContent = title;
        els.titleMax.classList.toggle('hidden', !title);
      }
      if (els.likeBtn) els.likeBtn.classList.toggle('is-active', !!v.isLiked);
    }

    function updateProductUI(v) {
      if (!els.card) return;
      if (!v.prodTitle) { els.card.classList.add('hidden'); return; }
      els.cardImg.src = v.prodImg || '';
      els.cardImg.alt = v.prodTitle;
      els.cardTitle.textContent = v.prodTitle;
      els.cardPrice.textContent = v.prodPrice || '';
      els.cardBtn.href = v.prodUrl || '#';
      var hideBtn = v.showBtn === false || (currentProduct && v.product === currentProduct);
      els.cardBtn.style.display = hideBtn ? 'none' : 'block';
      els.card.classList.remove('hidden');
    }

    // ── Carregamento: 1 vídeo por vez ─────────────────────────
    function loadVideo(index) {
      if (closed) return;
      if (!videoList.length) { hidePopup(); return; }

      currentIndex = ((index % videoList.length) + videoList.length) % videoList.length;
      window.inspirewebCurrentIndex = currentIndex;
      started = true;
      var v = videoList[currentIndex];

      allowPause(400);
      if (v.poster) video.poster = v.poster; else video.removeAttribute('poster');
      video.loop = !expanded;
      video.muted = isMuted;
      video.preload = 'auto';
      video.src = v.url; // só este vídeo é baixado

      updateTexts(v);
      updateProductUI(v);
      syncProgress(0);

      clearTimeout(stallTimer);
      stallTimer = setTimeout(function () {
        // Travou sem mostrar nada → recomeça o download uma vez
        if (videoList[currentIndex] === v && video.readyState < 2 && !v._kicked) {
          v._kicked = true;
          loadVideo(currentIndex);
        }
      }, STALL_TIMEOUT);

      play();
    }

    function handleFailure() {
      var v = videoList[currentIndex];
      if (closed || !v) return;
      clearTimeout(stallTimer);
      v._tries = (v._tries || 0) + 1;

      if (v._tries < 2) {
        // 1ª falha: tenta de novo o mesmo vídeo
        setTimeout(function () { if (videoList[currentIndex] === v) loadVideo(currentIndex); }, 1000);
        return;
      }
      // 2ª falha: tira da lista e segue pro próximo
      failedUrls[v.url] = true;
      videoList.splice(currentIndex, 1);
      buildPagination();
      if (!videoList.length) { hidePopup(); return; }
      loadVideo(currentIndex); // o próximo ocupou este índice
    }

    // Pré-carrega só o PRÓXIMO, e só quando o atual já está pronto e o player está aberto
    function preloadNext() {
      if (videoList.length < 2) return;
      var conn = navigator.connection;
      if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
      var next = videoList[(currentIndex + 1) % videoList.length];
      if (!next || next._preloaded) return;
      next._preloaded = true;
      if (next.poster) (new Image()).src = next.poster;
      if (!preloader) {
        preloader = document.createElement('video');
        preloader.muted = true;
        preloader.preload = 'auto';
        preloader.setAttribute('playsinline', '');
      }
      preloader.src = next.url;
    }

    // Move o mesmo <video> entre mini e expandido (sem baixar de novo)
    function setExpanded(open) {
      expanded = open;
      allowPause(500);
      if (open) els.area.insertBefore(video, els.area.firstChild);
      else els.mini.insertBefore(video, els.muteBtnMini || null);

      els.mini.classList.toggle('hidden', open);
      els.expanded.classList.toggle('hidden', !open);
      els.expanded.setAttribute('aria-hidden', String(!open));
      video.loop = !open;
      video.muted = isMuted;
      syncProgress(video.duration ? (video.currentTime / video.duration) * 100 : 0);
      play();
      if (open && video.readyState >= 4) preloadNext();
    }

    // ── Eventos do vídeo ──────────────────────────────────────
    video.addEventListener('loadeddata', function () {
      clearTimeout(stallTimer);
      var v = videoList[currentIndex];
      if (v) v._tries = 0;
      showPopup(); // só aparece com o 1º frame pronto
    });

    video.addEventListener('canplaythrough', function () {
      if (expanded) preloadNext();
    });

    video.addEventListener('error', function () {
      if (!closed && video.getAttribute('src')) handleFailure();
    });

    // Proteção contra pausa externa (modal quick-add etc.)
    video.addEventListener('pause', function () {
      if (closed || video.ended || Date.now() < pauseAllowedUntil) return;
      setTimeout(play, 50);
    });

    video.addEventListener('timeupdate', function () {
      if (expanded && video.duration > 0) syncProgress((video.currentTime / video.duration) * 100);
    });

    video.addEventListener('ended', function () {
      if (expanded) loadVideo(currentIndex + 1);
    });

    // ── Interações ────────────────────────────────────────────
    els.pagination && els.pagination.addEventListener('click', function (e) {
      var bar = e.target.closest('.bar');
      if (!bar) return;
      var idx = Array.prototype.indexOf.call(els.pagination.children, bar);
      if (idx !== -1) loadVideo(idx);
    });

    els.mini.addEventListener('click', function (e) {
      if (e.target.closest('button')) return;
      setExpanded(true);
    });

    els.mini.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('button')) {
        e.preventDefault();
        setExpanded(true);
      }
    });

    els.closeExpanded && els.closeExpanded.addEventListener('click', function (e) {
      e.stopPropagation();
      setExpanded(false);
    });

    els.closeMini && els.closeMini.addEventListener('click', function (e) {
      e.stopPropagation();
      closed = true;
      clearTimeout(stallTimer);
      allowPause(1000);
      video.pause();
      // Para o download de vez
      video.removeAttribute('src');
      video.load();
      if (preloader) { preloader.removeAttribute('src'); preloader.load(); }
      hidePopup();
    });

    function toggleMute(e) {
      e.stopPropagation();
      isMuted = !isMuted;
      video.muted = isMuted;
      updateMuteIcons();
      if (!isMuted) play();
    }
    els.muteBtnMini && els.muteBtnMini.addEventListener('click', toggleMute);
    els.muteBtn && els.muteBtn.addEventListener('click', toggleMute);

    els.area && els.area.addEventListener('click', function (e) {
      if (e.target.closest('button') || e.target.closest('.inspireweb-like-container')) return;
      loadVideo(currentIndex + 1);
    });

    els.cardBtn && els.cardBtn.addEventListener('click', function (e) { e.stopPropagation(); });

    els.likeBtn && els.likeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var v = videoList[currentIndex];
      if (!v) return;
      v.isLiked = els.likeBtn.classList.toggle('is-active');
      if (v.isLiked) {
        var heart = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        heart.setAttribute('viewBox', '0 0 24 24');
        heart.classList.add('floating-heart');
        heart.innerHTML = '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>';
        els.likeBtn.parentElement.appendChild(heart);
        setTimeout(function () { heart.remove(); }, 1000);
      }
    });

    // ── Inicialização ─────────────────────────────────────────
    // Vídeos do Klor que chegarem depois entram no fim da lista, sem reiniciar o player
    function mergeLateVideos() {
      var known = {};
      videoList.forEach(function (v) { known[v.url] = true; });
      var added = filterVideos().filter(function (v) { return !known[v.url]; });
      if (!added.length) return;
      videoList = videoList.concat(added);
      buildPagination();
      if (!started && !closed) loadVideo(0);
    }

    var klorTimeout = new Promise(function (r) { setTimeout(r, KLOR_MAX_WAIT); });
    Promise.race([klorReady, klorTimeout]).then(function () {
      videoList = filterVideos();
      buildPagination();
      if (videoList.length) loadVideo(0);
      klorReady.then(mergeLateVideos);
    });
  }
})();